// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"96cecc75","233":"87e612eb","486":"60f916c0","678":"f22238e3"}[chunkId] + ".css";
};